// extracted by mini-css-extract-plugin
module.exports = {"buttonComponent":"Button_buttonComponent__3Nt5P"};